import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './assets/css/old-style.css'
import './font'
import './i18n'
import App from './App.tsx'
import { initializeSentry } from './sentry'

// Initialize Sentry before rendering the app
initializeSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
